/*eslint-disable*/
import React, { useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatDistanceToNowStrict } from 'date-fns';
import { Lightbox } from 'react-modal-image';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Link,
  Theme,
  Typography,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';
import { useSelector } from 'src/store';
import { useDispatch } from 'react-redux';
import { markMessageAsSeen, toggleIsDocumentViewerOpen } from 'src/slices/chat';
import useSettings from 'src/hooks/useSettings';
// import { OPENAI_ID } from '../SelectModel';
import OpenAIIcon from 'src/icons/OpenAIIcon.svg';
import { ChatMessageWidth } from 'src/constants';
import ChatBotIcon from 'src/icons/chat-bot.svg';
import ChatLikeIcon from 'src/icons/chat-like-btn.svg';
import ChatDislikeIcon from 'src/icons/chat-dislike-btn.svg';
import ChatToolButton from './ChatToolButton';
import ReactMarkdown from 'react-markdown';
import { CopyIconButton } from 'src/components/CopyIconButton/index';
import TypingMarkdown from './TypingMarkdown';
import { ExpandMore, InfoOutlined, Refresh, SourceOutlined } from '@material-ui/icons';
import DocumentText from 'src/icons/DocumentText';
import colors from 'src/theme/colors';
import { extractFileName } from 'src/utils';
import { DEPARTMENTS, SECURITY_CLEARANCE } from 'src/components/navigation/MainNav';
import ThumbsUpDownDialog from './dialogs/ThumbsUpDownDialog';
import { getDocumentDownloadLink } from 'src/api/chat';
import { GetDocumentPayload } from 'src/types/chat';
import ChatLikeBtn from 'src/icons/ChatLikeBtn';
import ChatDislikeBtn from 'src/icons/ChatDislikeBtn';

interface ChatMessageProps {
  body: any;
  loader: any;
  contentType?: string;
  createdAt?: number;
  senderAvatar?: string;
  senderName?: string;
  senderType?: 'nbs' | 'contact' | 'user';
  threadKey?: any;
  thread?: any;
  index?: any;
  showIcons: boolean;
  msgId?: string;
  externalConvId?: string;
  msgLoading: boolean;
  reaction?: any;
  source_documents?: any;
  loadAtOnce?: boolean;
  onPdfDocClick: (url: string, source_documents: any) => void;
}

const ChatMessage: FC<ChatMessageProps> = (props) => {
  const {
    loader,
    body,
    contentType,
    senderAvatar,
    senderType,
    threadKey,
    thread,
    index,
    showIcons,
    msgId,
    externalConvId,
    msgLoading,
    reaction,
    source_documents = {},
    loadAtOnce = false,
    onPdfDocClick,
    ...other
  } = props;
  const dispatch = useDispatch();
  const [expandMedia, setExpandMedia] = useState<boolean>(false);
  const { activeThreadId } = useSelector((state) => state.chat);
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down(760));
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const { selectedModel } = thread;
  const { byId = {} } = useSelector((state) => state.metadata);
  const hasSourceDocuments = Object.keys(source_documents ?? {}).length > 0;
  // const [animationCompleted, setAnimationCompleted] = useState<boolean>(false);
  const { settings } = useSettings();

  const [thumbsUpDownDialogOpen, setThumbsUpDownDialogOpen] = useState({
    open: false,
    btnCliked: '',
    msgId: null,
  });


  const selectAvatarSrc = () => {
    // let avatarIcon;
    // if (body.icon === 'DEFAULT' || body === 'showLoader') {
    //   if (selectedModel == OPENAI_ID) {
    //     avatarIcon = OpenAIIcon; // OPENAI
    //   } else {
    //     avatarIcon = ChatBotIcon;
    //   }
    // } else {
    //   avatarIcon = body.icon;
    // }
    return ChatBotIcon;
  };

  function moment(createdAt: number) {
    throw new Error('Function not implemented.');
  }

  const handlePdfDocClick = (event, url, source_docs) => {
    // Handle the PDF document click event
    event.preventDefault();
    // const url = event.currentTarget.getAttribute('href');

    if (url) {
      const payload: GetDocumentPayload = {
        url: url
      }
      getDocumentDownloadLink(payload).then(resp => resp?.data).then(response => {

        console.log(source_docs);

        onPdfDocClick(response.presigned_url, source_docs);
      })
        .catch(err => {

        });




    }

  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background:
            senderType === 'user'
              ? smDown
                ? 'white'
                : 'background.default'
              : '#F3F3F3',
          py: 2,
        }}
        {...other}
      >
        <Box
          sx={{
            display: 'flex',
            maxWidth: ChatMessageWidth,
            width: '100%',
            justifyContent: 'space-between',
            flexDirection: !smDown ? 'row' : 'column',
            px: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: !smDown ? 'center' : 'flex-start',
              width: !smDown ? '87%' : '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              {senderType === 'user' ? (
                <Avatar
                  variant="square"
                  className="user-avatar"
                  src={senderAvatar}
                  sx={{
                    height: 30,
                    width: 30,
                    borderRadius: '5px',
                  }}
                />
              ) : (
                <Avatar
                  variant="square"
                  sx={{
                    height: 30,
                    width: 30,
                    borderRadius: '5px',
                    backgroundColor: 'transparent',
                  }}
                >
                  <img
                    src={selectAvatarSrc()}
                    style={{ height: '30px', width: '30px' }}
                  />
                </Avatar>
              )}
            </Box>
            <Box
              sx={{
                marginLeft: '4px',
                marginTop: !smDown ? '0px' : '4px',
              }}
            >
              <Box
                sx={{
                  color:
                    settings.theme == 'DARK'
                      ? senderType === 'user'
                        ? '#3C4A59'
                        : 'white'
                      : '#3C4A59',
                  px: 1,
                }}
              >
                <Box sx={{ mt: 0, ml: 1 }}>
                  {contentType === 'image' ? (
                    <Box
                      onClick={(): void => setExpandMedia(true)}
                      sx={{
                        mt: 2,
                        '& img': {
                          cursor: 'pointer',
                          height: 'auto',
                          maxWidth: '100%',
                        },
                      }}
                    >
                      <img alt="Attachment" src={body} />
                    </Box>
                  ) : (
                    <Typography
                      color="inherit"
                      variant="body1"
                      sx={{
                        fontSize: {
                          xs: '0.875rem',
                          sm: '0.875rem',
                          md: '0.875rem',
                          lg: '1rem',
                          xl: '1.125rem'
                        },
                        color: '#3C3C3C',
                      }}
                    >
                      {senderType == 'nbs' &&
                        body !== 'showLoader' &&
                        !showIcons ? (
                        <TypingMarkdown
                          content={body}
                          speed={20}
                          threadId={thread?.external_chat_id}
                          showTyping={!loadAtOnce}
                          msgId={msgId}
                          onTypingComplete={async () => {
                            await dispatch(
                              markMessageAsSeen(thread?.external_chat_id, msgId, true)
                            );
                          }}
                        />
                      ) : senderType === 'nbs' && body === 'showLoader' ? (
                        loader
                      ) : (
                        <TypingMarkdown
                          content={body}
                          speed={20}
                          showTyping={false}
                          msgId={msgId}
                          threadId={''}
                          onTypingComplete={() => { }}
                        />
                      )}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          {senderType == 'nbs' &&
            showIcons && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: !smDown ? 'space-between' : 'flex-end',
                  height: '100%',
                  alignItems: 'center',
                  ml: 0,
                }}
              >

                {/* <>
                <ChatToolButton
                  src={<CopyIconButton value={body} />}
                  onClick={() => { }}
                />
                {false && (
                  <ChatToolButton
                    sx={{ p: 0, mx: 1 }}
                    src={ChatLikeIcon}
                    onClick={() => { }}
                  />
                )}
                {false && (
                  <ChatToolButton src={ChatDislikeIcon} onClick={() => { }} />
                )}
              </> */}
              </Box>
            )}
          {senderType == 'nbs' &&
            showIcons && hasSourceDocuments && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: !smDown ? 'space-between' : 'flex-end',
                  height: '100%',
                  alignItems: 'center',
                  ml: 0,
                }}
              >
                <ChatToolButton
                  sx={{ p: 0, mx: 0.5, float: 'inline-end' }}
                  src={<CopyIconButton value={body} />}
                  onClick={() => { }}
                />

                {reaction == null || reaction.thumbs_up ? (
                  <ChatToolButton
                    tooltipText={reaction?.thumbs_up ? reaction?.feedback : ""}
                    disabled={reaction && reaction?.thumbs_up}
                    sx={{ p: 0, mx: 0.5, float: 'inline-end' }}
                    src={<ChatLikeBtn style={{ color: reaction?.thumbs_up ? '#0c62fb' : 'lightgray', alignSelf: 'start' }} sx={{ strokeWidth: '1.5' }} />}
                    onClick={() => {
                      reaction == null
                        ? setThumbsUpDownDialogOpen((prev) => {
                          return {
                            ...prev,
                            open: true,
                            btnCliked: 'like',
                            msgId: externalConvId,
                          };
                        })
                        : null;
                    }}
                  />
                ) : null}

                {reaction == null || reaction.thumbs_down ? (
                  <ChatToolButton
                    tooltipText={reaction?.thumbs_down ? reaction?.feedback : ""}
                    disabled={reaction && reaction?.thumbs_down}
                    sx={{ p: 0, mx: 0.5, float: 'inline-end' }}
                    src={<ChatDislikeBtn style={{ color: reaction?.thumbs_down ? 'red' : 'lightgray', alignSelf: 'start' }} sx={{ strokeWidth: '1.5' }} />}
                    onClick={() => {
                      reaction == null
                        ? setThumbsUpDownDialogOpen((prev) => {
                          return {
                            ...prev,
                            open: true,
                            btnCliked: 'dislike',
                            msgId: externalConvId,
                          };
                        })
                        : null;
                    }}
                  />
                ) : null}
                <ChatToolButton
                  sx={{ p: 0, mx: 0.5, float: 'inline-end' }}
                  src={
                    <Refresh
                      sx={{
                        color: 'lightgray',
                        fill: 'lightgray',
                        transform: 'scaleX(-1)',
                        '&:hover': {
                          color: 'darkgray',
                          fill: 'darkgray',
                        },
                      }}
                    />
                  }
                  onClick={() => { }}
                />
                <ChatToolButton
                  src={
                    <InfoOutlined
                      sx={{
                        color: 'lightgray',
                        fill: 'lightgray',
                        '&:hover': {
                          color: 'darkgray',
                          fill: 'darkgray',
                        },
                      }}
                    />
                  }
                  sx={{ p: 0, mx: 0.5, float: 'inline-end' }}
                  onClick={() => setShowDetails(!showDetails)}
                />
                {/* <ChatToolButton src={ChatDislikeIcon} onClick={() => { }} /> */}
                {/* <InfoOutlined onClick={ } sx={{ color: '#888', cursor: 'pointer' }} /> */}

                {/* <>
                <ChatToolButton
                  src={<CopyIconButton value={body} />}
                  onClick={() => { }}
                />
                {false && (
                  <ChatToolButton
                    sx={{ p: 0, mx: 1 }}
                    src={ChatLikeIcon}
                    onClick={() => { }}
                  />
                )}
                {false && (
                  <ChatToolButton src={ChatDislikeIcon} onClick={() => { }} />
                )}
              </> */}
              </Box>
            )}
        </Box>
      </Box>
      {
        senderType == 'nbs' &&
        showIcons && (
          <Box className={`${!showDetails || !hasSourceDocuments ? 'hide' : ''}`}
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Accordion elevation={0} disableGutters sx={{
              borderTop: theme => `1px solid ${theme.palette.divider}`,
              borderBottom: theme => `1px solid ${theme.palette.divider}`,
              maxWidth: ChatMessageWidth,
              width: '100%',
              px: 2,
            }}
            >
              <AccordionSummary sx={{ margin: 0, height: '2rem', minHeight: '2rem' }}>
                <Typography sx={{ fontSize: '.875rem', display: 'flex', alignItems: 'center' }}>Documents
                  <Chip sx={{
                    marginLeft: '0.25rem',
                    height: '1rem',
                    borderRadius: '0.25rem',
                    fontSize: '0.75rem',
                    'span': {
                      padding: '0.25rem',
                    }
                  }} variant='outlined' label="source_documents" />
                  <Chip sx={{
                    marginLeft: '0.25rem',
                    height: '1rem',
                    borderRadius: '0.25rem',
                    fontSize: '0.75rem',
                    'span': {
                      padding: '0.25rem',
                    }
                  }} variant='filled' label={Object.keys(source_documents).length} /></Typography>
              </AccordionSummary>
              <AccordionDetails>
                {source_documents && Object.keys(source_documents).map(sd => (
                  <Accordion disableGutters sx={{ border: theme => `1px solid ${theme.palette.divider}` }}>
                    <AccordionSummary sx={{
                      margin: 0,
                      height: '2rem',
                      minHeight: '2rem',
                      '.MuiAccordionSummary-content': {
                        display: 'flex', alignItems: 'center',
                      }
                    }} expandIcon={<ExpandMore />}>
                      <DocumentText sx={{ width: '1rem' }} />
                      <Typography sx={{ marginLeft: '0.5rem', fontSize: '.875rem', }}>{extractFileName(sd) ?? 'Document'}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ overflow: 'auto' }}>
                      {source_documents[sd].map(doc => (
                        <>
                          <Typography sx={{ width: '55vw', marginTop: '0.625rem', marginBottom: '0.625rem', maxWidth: '800px', fontSize: theme => theme.typography.pxToRem(14) }}>
                            {doc?.page_content}
                          </Typography>
                          <Typography sx={{
                            background: colors.lightGreyFiftyPercent,
                            padding: '8px 5px',
                            borderRadius: '2px',
                            fontSize: theme => theme.typography.pxToRem(14),
                            display: 'inline'
                          }}>
                            <b>euclidean distance: </b>
                            {(parseFloat(doc.euclideanDistance) * 100).toFixed(2)}
                          </Typography>
                        </>
                      )
                      )}
                      <Box sx={{
                        borderTop: '1px solid #DCDCDC',
                        paddingTop: '0.5rem',
                        marginTop: theme => theme.typography.pxToRem(16),
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: theme => theme.typography.pxToRem(8),
                        justifyContent: 'flex-start',
                        flexWrap: 'wrap',
                      }}>
                        {/* <Typography sx={{
                          background: colors.lightGreyFiftyPercent,
                          padding: '8px 5px',
                          borderRadius: '2px',
                          fontSize: theme => theme.typography.pxToRem(14),
                          display: 'inline'
                        }}>
                          <b>page: </b>
                          {'  '}
                          {'5'}
                        </Typography> */}

                        <Typography sx={{
                          background: colors.lightGreyFiftyPercent,
                          padding: '8px 5px',
                          borderRadius: '2px',
                          fontSize: theme => theme.typography.pxToRem(14),
                          display: 'inline'
                        }}>
                          <b>source:</b>
                          {'  '}
                          <a href={sd} onClick={(ev) => handlePdfDocClick(ev, sd, source_documents[sd])} target='_blank'>{extractFileName(sd) ?? ''}</a>
                        </Typography>

                        <Typography sx={{
                          background: colors.lightGreyFiftyPercent,
                          padding: '8px 5px',
                          borderRadius: '2px',
                          fontSize: theme => theme.typography.pxToRem(14),
                          display: 'inline'
                        }}>
                          <b>department: </b>
                          {byId[source_documents[sd]?.[0]?.metadata?.department_id]}
                        </Typography>
                        <Typography sx={{
                          background: colors.lightGreyFiftyPercent,
                          padding: '8px 5px',
                          borderRadius: '2px',
                          fontSize: theme => theme.typography.pxToRem(14),
                          display: 'inline'
                        }}>
                          <b>security level: </b>
                          {SECURITY_CLEARANCE[source_documents[sd]?.[0]?.metadata?.security_level?.toLowerCase()]}
                        </Typography>
                      </Box>
                    </AccordionDetails >
                  </Accordion >
                ))}
              </AccordionDetails >
            </Accordion >
          </Box >
        )}
      <ThumbsUpDownDialog
        open={thumbsUpDownDialogOpen}
        setOpen={setThumbsUpDownDialogOpen}
      />
    </>
  );
};

ChatMessage.propTypes = {
  loader: PropTypes.any,
  body: PropTypes.any.isRequired,
  senderAvatar: PropTypes.string.isRequired,
  senderType: PropTypes.oneOf(['nbs', 'user']),
  threadKey: PropTypes.any,
  thread: PropTypes.any,
  index: PropTypes.any,
  showIcons: PropTypes.bool,
  msgId: PropTypes.string,
  externalConvId: PropTypes.string,
};

export default React.memo(ChatMessage);
